import { Box } from "@mui/material";
import { IconStarFilled } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import Text from "../../../../components/ui/Text";
import { Gallery, User } from "./parts";

// Animation will be triggered when section enters viewport

export const Comment = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.4,
        rootMargin: "0px 0px -50px 0px",
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        justifyContent: "space-between",
        height: { md: "calc(100dvh - 80px)" },
      }}
    >
      <Box
        sx={{
          width: { md: "50%" },
          backgroundColor: "#ffffff",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingBottom: { xs: 6, md: 0 },
        }}
      >
        <Box
          sx={{
            maxWidth: 452,
            pt: { xs: 6, md: 0 },
            px: { xs: 2, md: 10 },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text
            component="h2"
            mb={4}
            sx={{
              fontSize: { xs: "28px", sm: "5.5vw", md: "42px" },
              fontWeight: 900,
              color: "#171717",
              lineHeight: "100%",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(30px)",
              transition: "all 0.8s ease-out 0.2s",
            }}
          >
            Loved and trusted by hosts.
          </Text>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              p: 2,
              border: "1px solid #ccc",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              padding: { xs: "24px 16px", md: "32px 24px" },
              opacity: isVisible ? 1 : 0,
              transition: "all 0.8s ease-out 0.6s",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "6px",
                alignItems: "center",
                mb: 2,
              }}
            >
              {Array(5)
                .fill(0)
                .map((_, index) => (
                  <IconStarFilled key={index} size={22} color="#FBBF24" />
                ))}
            </Box>
            <Text
              variant="paragraph2"
              sx={{
                fontSize: { xs: "13px", md: "16px" },
                lineHeight: { xs: "18px", md: "24px" },
                color: "#0A0A0A",
              }}
            >
              “I've been using Findaside for years. I use it to run my weekly
              football game. The payment tracking and recurring games saves me a
              lot of time. It's a life saver.”
            </Text>
            <User />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: { md: "50%" },
          backgroundColor: "#ffffff",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <Gallery />
      </Box>
    </Box>
  );
};
